export default "__VITE_PUBLIC_ASSET__adea8b54__"